export default function transformAnalyticsFiles(analyticsFiles) {
  return analyticsFiles.map(file => ({
    ...file,
    identitySyncs: file.analytics_file_identity_syncs.map(({ identity_sync }) => ({
      name: identity_sync.name,
      friendlyName: identity_sync.friendlyName,
    })),
  }));
}
